import React from 'react';

import { Skeleton } from '../../../../components';
import { StatValue } from '../StatValue';
import { Delta } from '../Delta';
import { Root, LabelRow, Lbl, PVal, DeltaRow, Sub } from './PrimaryStat.styles';

export type PrimaryStatProps = {
  label: string;
  value: number;
  prefix?: string;
  suffix?: string;
  delta: number;
  /** Comparison caption ("vs last month"). */
  sub: string;
  /** While true, the figure + its delta show placeholders (the endpoint is loading). */
  loading?: boolean;
  /** The backing API request is failing: render `N/A` and suppress the delta row. */
  error?: boolean;
};

/**
 * The lead figure of a metric card (Gross Revenue, Deposits): a label, the
 * prominent counted-up value and a delta + caption row beneath. The label +
 * caption are static chrome; the figure + delta load in.
 */
export const PrimaryStat = ({ label, value, prefix, suffix, delta, sub, loading = false, error = false }: PrimaryStatProps): React.ReactElement => (
  <Root>
    <LabelRow>
      <Lbl text={label} tag="span" />
    </LabelRow>
    <PVal>
      <StatValue value={value} prefix={prefix} suffix={suffix} loading={loading} error={error} />
    </PVal>
    {/* On error there is no real delta — drop the whole delta + caption row. */}
    {!error ? (
      <DeltaRow>
        {loading ? <Skeleton width={44} height={18} radius={8} /> : <Delta value={delta} />}
        <Sub text={sub} tag="span" />
      </DeltaRow>
    ) : null}
  </Root>
);

export default PrimaryStat;
